import { AlphaICircleOutlineIcon } from './AlphaICircleOutlineIcon';

/**
 * author: Contributors
 * id 4AAE84B4-CF3E-4736-A420-DD188452F819
 * name alpha-i-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-i-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetICircleOutlineIcon = AlphaICircleOutlineIcon;
export default AlphabetICircleOutlineIcon